module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Riwayat Konsultasi'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold font-size-20 mt-3 mb-4"
  }, [_vm._v("\n        Riwayat Konsultasi\n    ")]), _vm._v(" "), _c('consul-history-list')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f640ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/ConsulHistory.vue
// module id = 1643
// module chunks = 1